export default "<div class=\"sx-modal-overlay modal-lote\">\n    <div class=\"modal-content\">\n        {{{ card }}}\n    </div>\n</div>\n"